import api from '../api/client';
import toast from 'react-hot-toast';

/**
 * openPrintTab(path)
 *
 * 1. Calls POST /api/qr-print/token (with normal Bearer) → gets a 15-min print token
 * 2. Opens a new tab: /api/qr-print/<path>?pt=<printToken>
 *
 * This avoids the problem of passing a full access token in a URL while still
 * allowing the print page to open in a plain new browser tab.
 */
export const openPrintTab = async (printPath) => {
  const toastId = toast.loading('Preparing print page…');
  try {
    const { data } = await api.post('/qr-print/token');
    const pt       = data.data.printToken;
    const apiBase  = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api')
                       .replace(/\/api\/?$/, '');          // strip trailing /api
    const url      = `${apiBase}/api/qr-print/${printPath}?pt=${encodeURIComponent(pt)}`;
    toast.success('Opening print page…', { id: toastId });
    window.open(url, '_blank', 'noopener');
  } catch (err) {
    toast.error(err.response?.data?.message || 'Failed to open print page', { id: toastId });
  }
};
